__turbopack_context__.v({
  "addressBar": "ServicosModule-module__A87wDG__addressBar",
  "browserBar": "ServicosModule-module__A87wDG__browserBar",
  "btnFaturar": "ServicosModule-module__A87wDG__btnFaturar",
  "checkCard": "ServicosModule-module__A87wDG__checkCard",
  "checkIcon": "ServicosModule-module__A87wDG__checkIcon",
  "checkItem": "ServicosModule-module__A87wDG__checkItem",
  "checkText": "ServicosModule-module__A87wDG__checkText",
  "customForm": "ServicosModule-module__A87wDG__customForm",
  "dashboardBody": "ServicosModule-module__A87wDG__dashboardBody",
  "desktopMockup": "ServicosModule-module__A87wDG__desktopMockup",
  "done": "ServicosModule-module__A87wDG__done",
  "dots": "ServicosModule-module__A87wDG__dots",
  "fLabel": "ServicosModule-module__A87wDG__fLabel",
  "fValue": "ServicosModule-module__A87wDG__fValue",
  "fadeIn": "ServicosModule-module__A87wDG__fadeIn",
  "fieldInput": "ServicosModule-module__A87wDG__fieldInput",
  "fieldLabel": "ServicosModule-module__A87wDG__fieldLabel",
  "financeAction": "ServicosModule-module__A87wDG__financeAction",
  "financeTotal": "ServicosModule-module__A87wDG__financeTotal",
  "formField": "ServicosModule-module__A87wDG__formField",
  "formGrid": "ServicosModule-module__A87wDG__formGrid",
  "formSelector": "ServicosModule-module__A87wDG__formSelector",
  "full": "ServicosModule-module__A87wDG__full",
  "integrationCard": "ServicosModule-module__A87wDG__integrationCard",
  "internalNote": "ServicosModule-module__A87wDG__internalNote",
  "mockupContainer": "ServicosModule-module__A87wDG__mockupContainer",
  "noteText": "ServicosModule-module__A87wDG__noteText",
  "noteTitle": "ServicosModule-module__A87wDG__noteTitle",
  "osCard": "ServicosModule-module__A87wDG__osCard",
  "osClient": "ServicosModule-module__A87wDG__osClient",
  "osDate": "ServicosModule-module__A87wDG__osDate",
  "osFooter": "ServicosModule-module__A87wDG__osFooter",
  "osHeader": "ServicosModule-module__A87wDG__osHeader",
  "osList": "ServicosModule-module__A87wDG__osList",
  "osNumber": "ServicosModule-module__A87wDG__osNumber",
  "osPrice": "ServicosModule-module__A87wDG__osPrice",
  "osStatus": "ServicosModule-module__A87wDG__osStatus",
  "osTitle": "ServicosModule-module__A87wDG__osTitle",
  "partItem": "ServicosModule-module__A87wDG__partItem",
  "partName": "ServicosModule-module__A87wDG__partName",
  "partPrice": "ServicosModule-module__A87wDG__partPrice",
  "partStock": "ServicosModule-module__A87wDG__partStock",
  "partsList": "ServicosModule-module__A87wDG__partsList",
  "sectionTitle": "ServicosModule-module__A87wDG__sectionTitle",
  "slideIn": "ServicosModule-module__A87wDG__slideIn",
  "statusDone": "ServicosModule-module__A87wDG__statusDone",
  "statusOpen": "ServicosModule-module__A87wDG__statusOpen",
  "statusProgress": "ServicosModule-module__A87wDG__statusProgress",
  "uncheckIcon": "ServicosModule-module__A87wDG__uncheckIcon",
});
